import React from 'react';
import { ShoppingCart } from 'lucide-react';
interface ButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
}
export function Button({
  children,
  className = '',
  showIcon = true,
  ...props
}: ButtonProps) {
  return <a href="https://checkout.ebookpoint.shop/cart/59567230648401:1" target="_blank" rel="noopener noreferrer" className={`
        relative inline-flex items-center justify-center gap-3 
        bg-brand-pink text-white font-bold text-lg md:text-xl 
        py-4 px-8 rounded-full uppercase tracking-wide
        transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(255,0,128,0.5)]
        active:scale-95 overflow-hidden group
        ${className}
      `} {...props} data-id="element-164">
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-165"></div>
      <span className="relative z-10 flex items-center gap-2" data-id="element-166">
        {showIcon && <ShoppingCart className="w-6 h-6 animate-bounce" data-id="element-167" />}
        {children}
      </span>
    </a>;
}